import { useEffect, useState } from "react";
import PricingCard from "../components/cards/Pricing-card.tsx";
import { content } from "../data.tsx";
import Header from "../layout/Header.tsx";
import { useSearchParams } from "react-router-dom";
import Footer from "../layout/Footer.tsx";
import SubscriptionInfoModel from "../models/subscription-info-model.tsx";

const Pricing = () => {
  const [activeCardIndex] = useState(null);
  const [isMonthly, setIsMonthly] = useState(true);
  const [params, setParams] = useSearchParams();
  const [subModel, setSubModel] = useState<"unpaid" | "no-subscription" | null>(
    null
  );

  useEffect(() => {
    const subid = params.get("id");
    const subtype = params.get("subtype");
    if (subid || subtype) {
      subid !== "undefined" && subtype !== "undefined"
        ? setSubModel(subtype as any)
        : setSubModel("no-subscription");
      params.delete("id");
      params.delete("subtype");
      setParams(params);
    }
  }, []);

  return (
    <>
      <Header className={"bg-white"} />
      <div className="w-full py-16 lg:py-24 bg-white gap-6 flex flex-col justify-center items-center max-w-[1440px] mx-auto px-4">
        <span className="text-blue text-xs font-medium tracking-widest uppercase">Pricing</span>
        <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-lightBlack text-center">
          Choose your <span className="text-blue">plan</span>
        </h1>
        <p className="text-gray-500 text-base lg:text-lg max-w-2xl text-center leading-relaxed">
          Simple, transparent pricing that grows with you. Cancel anytime.
        </p>

        <div className="flex w-full max-w-md bg-gray-50 border border-gray-100 rounded-full p-1.5 mt-2">
          <button
            className={`items-center justify-center self-stretch flex w-1/2 py-2.5 rounded-full text-sm font-medium transition-all duration-200 ${
              isMonthly
                ? "bg-white text-blue shadow-soft"
                : "bg-transparent text-gray-500 hover:text-lightBlack"
            }`}
            onClick={() => setIsMonthly(true)}
          >
            Monthly
          </button>
          <button
            className={`items-center justify-center flex self-stretch w-1/2 py-2.5 rounded-full text-sm font-medium transition-all duration-200 ${
              !isMonthly
                ? "bg-white text-blue shadow-soft"
                : "bg-transparent text-gray-500 hover:text-lightBlack"
            }`}
            onClick={() => setIsMonthly(false)}
          >
            Yearly <span className="ml-1.5 text-[11px] font-medium px-2 py-0.5 rounded-full bg-yellow/20 text-yellow-700">Save 25%</span>
          </button>
        </div>

        <div className="w-[95%] max-w-[1280px] mt-10 flex lg:flex-row flex-col items-stretch justify-center gap-6">
          {content.pricingPlans.map((plan, index) => (
            <PricingCard
              key={index}
              ind={index}
              title={plan.title}
              subtitle={plan.subtitle}
              type={plan.type}
              features={plan.features}
              isActive={index === activeCardIndex}
              isMonthly={isMonthly}
              euroPrice={plan?.euroPrice}
            />
          ))}
        </div>
      </div>
      <Footer />

      {subModel !== null ? (
        <SubscriptionInfoModel
          type={subModel}
          toggleModel={() => setSubModel(null)}
        />
      ) : null}
    </>
  );
};

export default Pricing;
